import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { apiClient } from "@/api/endpoints";
import { useAuth } from "@/features/auth";

export const Route = createFileRoute("/auth/logout")({
  beforeLoad: async () => {
    await apiClient.auth.signOut();
  },
  component: RouteComponent,
  head: () => ({
    meta: [
      {
        title: "Logger ut | Norgespris for Fjernvarme",
      },
    ],
  }),
});

function RouteComponent() {
  const router = useRouter();
  const { resetAccount } = useAuth();

  useEffect(() => {
    const logout = async () => {
      await resetAccount();
      await router.navigate({ to: "/" });
    };
    logout();
  }, [resetAccount, router]);

  return null;
}
